

export default function BrandStoryModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      <div
        className="relative bg-white rounded-3xl max-w-lg w-full p-8 z-10 max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-gray-600" />
        </button>

        <h2 className="text-2xl font-extrabold text-gray-900 mb-5">Our Brand Story</h2>

        <div className="space-y-4 text-gray-600 text-sm leading-relaxed">
          <p>
            In a fast-paced world where convenience meets craving,{' '}
            <strong className="text-gray-900">Sweetplate</strong> was born to redefine how people
            experience food — one delicious meal and one thriving city at a time.
          </p>
          <p>
            Sweetplate isn&apos;t just a food delivery platform — it&apos;s a{' '}
            <strong className="text-gray-900">culinary ecosystem</strong> built on trust, taste,
            and technology. From local restaurants to global fast-food chains, Sweetplate connects
            food lovers to endless flavors through a smooth, modern experience.
          </p>
          <p>
            At the heart of this movement is the{' '}
            <strong className="text-gray-900">Sweetplate Coin (SPC)</strong> — a token that grows
            in value as the network expands across cities, adding liquidity and community-driven
            value.
          </p>
          <p>
            Users can stake SPC and earn{' '}
            <strong className="text-gray-900">daily dividends or APY</strong>, turning each food
            order into an opportunity for wealth creation.
          </p>
          <blockquote className="border-l-4 border-[#009E81] pl-4 italic text-gray-700 bg-gray-50 py-3 pr-4 rounded-r-lg">
            &ldquo;To revolutionize fast-food delivery through blockchain innovation — rewarding
            customers, empowering restaurants, and building the world&apos;s first culinary token
            economy.&rdquo;
          </blockquote>
          <p>
            As our ecosystem expands, the coin grows, the community strengthens, and the future of
            food becomes not just delicious — but decentralized.
          </p>
        </div>

        <div className="mt-6 flex gap-3">
          <button className="flex-1 bg-[#009E81] text-white font-semibold py-3 rounded-xl hover:bg-[#008570] transition-colors cursor-pointer whitespace-nowrap">
            Buy SPC Now
          </button>
          <button
            onClick={onClose}
            className="flex-1 border-2 border-gray-200 text-gray-700 font-semibold py-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
